import { encryptData, getOtpFromKey } from "./utils";

type AnalyticsHeader = {
  c1: string;
  c2?: string;
  c3: string;
  c4?: string;
};

const analyticsSign: string = import.meta.env.PUBLIC_ANALYTICS_SIGN;
const analyticsT: string = import.meta.env.PUBLIC_ANALYTICS_T;

export const createAnalyticsHeader = async () => {
  const analytics: AnalyticsHeader = {
    c1: "d1sa4a",
    c2: "5QszZY",
    c3: getOtpFromKey(analyticsT),
  };

  const header = `totally${JSON.stringify(analytics)}spice`;
  const reverseString = await encryptData(header.split("").reverse().join(""), analyticsSign);

  return reverseString;
};
